import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import ArtistList from "./ArtistList";
import { RemovableArtist } from "components/Removables/RemovableArtist";
import { ModalPickerProps } from "../props";
import { useOpenNewCompanySidePanel } from "components/SidePanel/Company/NewCompanySidePanel";
import { companyToArtist } from "shared/utils/companyUtils";
import { AfterCreateAction } from "components/SidePanel/types";

type Props = Omit<ModalPickerProps<server.dto.ArtistSmall>, "canCreateNew"> & {
  securityScope: server.dto.ArtistSecurityScopes;
} & (
    | { canCreateNew: false; afterCreate?: AfterCreateAction }
    | { canCreateNew: boolean; afterCreate: AfterCreateAction }
  );

const ArtistModalPicker = (props: Props) => {
  const openNewCompanySidePanel = useOpenNewCompanySidePanel();
  const onChange = (value: server.dto.ArtistSmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  return <>
    <ModalPickerWithChooseButton
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.artist.plural}
      modalSize="tiny"
      renderModalContent={(closeModal) => <ArtistList
        securityScope={props.securityScope}
        onItemSelected={(artist) => {
          closeModal();
          onChange(artist);
        }}
      />}
      renderRemovable={(props) => <RemovableArtist {...props} />}
      onNewClicked={() => openNewCompanySidePanel({
        type: "artist",
        disableArtist: true,
        onCreated: (c) => onChange(companyToArtist(c)),
        afterCreate: props.afterCreate ?? "closeSidebar"
      })}

      {...props}
    />
  </>;
};

export default ArtistModalPicker;